import moment from "moment";

export const TELEMED_CALL_WINDOW_MINUTES = 60;

export const formatTelemedCallWindow = (start?: Date | string | null) => {
  if (!start) return "";
  const from = moment(start);
  const to = moment(start).add(TELEMED_CALL_WINDOW_MINUTES, "minutes");
  return `${from.format("HH:mm")} - ${to.format("HH:mm")}`;
};

export const secondsToTime = (secs: number) => {
  const minutes = Math.floor(secs / 60);
  const seconds = secs % 60;
  const timeString =
    minutes > 0
      ? `${minutes} minute${minutes > 1 ? "s" : ""} ${seconds} second${
          seconds !== 1 ? "s" : ""
        }`
      : `${seconds} second${seconds !== 1 ? "s" : ""}`;
  return timeString;
};
